<template>
	<app>
		<crumb-bar></crumb-bar>
		<menu-aside>
			<m-search @search="updateList">
				<c-form>
					<c-form-item type="input" label="项目编号" name="code"></c-form-item>
					<c-form-item type="input" label="项目名称" name="name"></c-form-item>
					<c-form-item type="input" label="业主单位" name="yzdw_name"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
				<c-button icon="add" @click="editHandle()">新建项目</c-button>
			</m-operate>
			
			<c-table ref="table">
				<c-table-column
					label="项目状态"
					width="130"
				>
					<template v-slot="{data}">
						<span v-if="projectState[data.state]" :style="{'color': projectState[data.state].color}">{{projectState[data.state].name}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="项目编号"
					name="code"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="项目名称"
					name="name"
					width="250"
				></c-table-column>
				
				<c-table-column
					label="业主单位"
					name="yzdw_name"
					width="300"
				></c-table-column>
				
				<c-table-column
					type="button"
					label="操作"
					width="160"
					limit="2"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo('/transact/project/detail', {id: data.id}, true)">详情</c-table-button>
						<c-table-button v-if="data.state < 3" @click="editHandle(data)">编辑</c-table-button>
						<c-table-button v-if="data.state == 3" @click="$refs.bidding.open(data.id)">设置中标企业</c-table-button>
						<c-table-button v-if="data.state == 1" @click="deleteHandle(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</menu-aside>
		
		<c-dialog ref="editProject" width="750" height="600" button-name="确认并提交" @resolve="editSubmitHandle">
			<c-form ref="editProjectForm" unit-width="400">
				<c-form-item type="hidden" name="project_id"></c-form-item>
				<c-form-item type="input" label="项目编号" name="code" placeholder="自动生成" required disabled></c-form-item>
				<c-form-item type="input" label="项目名称" name="name" required @change="validName"></c-form-item>
				<c-form-item v-model="currentYzdw" type="select" label="所属业主单位" name="yzdw_id" required options="OWNER_UNIT"></c-form-item>
				<c-form-item type="select" label="所属组织部门" name="yzdw_organization_id" required :options="departmentList"></c-form-item>
				<c-form-item type="select" label="所属行业" name="sshy" required options="INDUSTRY"></c-form-item>
				<c-form-item type="region" label="项目建设地址" province-name="province" city-name="city" county-name="district" address-name="address" required></c-form-item>
				<c-form-item type="file" label="招标文件" name="files_path" required file-type="word,excel,pdf,zip,image"></c-form-item>
				<c-form-item type="radio" label="招标代理费付款方" name="zbdl_money_user_type" required :options="proxyMoneyOptions"></c-form-item>
				<c-form-item type="input" label="业主单位联系人" name="yzdw_lxr"></c-form-item>
				<c-form-item type="input" label="业主单位联系电话" name="yzdw_lxdh"></c-form-item>
				<c-form-item type="textarea" label="备注说明" name="remark"></c-form-item>
			</c-form>
		</c-dialog>
		
		<bidding-company ref="bidding" @resolve="$refs.table.update()"></bidding-company>
	</app>
</template>

<script>
	import biddingCompany from './bidding_company.vue'
	import {mapGetters} from 'vuex'
	
	export default {
		components: {
			biddingCompany
		},
		
		data() {
			return {
				proxyMoneyOptions: [{
					name: '企业',
					value: 1
				}, {
					name: '业主',
					value: 2
				}],
				currentYzdw: '',
				departmentList: []
			}
		},
		
		computed: {
			...mapGetters(['projectState'])
		},
		
		watch: {
			currentYzdw(val) {
				this.request({
					url: '/yzdw/organization/selectList',
					data: {
						yzdw_id: val
					},
					success: data => {
						this.departmentList = Array.from(data, item => {
							return {
								name: item.organization_name,
								value: item.organization_id.toString()
							}
						});
						this.$nextTick(() => {
							this.$refs.editProjectForm.set({
								yzdw_organization_id: ''
							});
						})
					}
				});
			}
		},
		
		mounted() {
			this.updateList();
		},
		
		methods: {
			updateList(data) {
				this.$refs.table.load({
					url: '/project/list',
					data
				});
			},
			
			validName(name) {
				this.request({
					url: '/project/existsName',
					data: {
						project_id: 0,
						name
					},
					fail: () => {
						this.$refs.editProjectForm.set({
							name: ''
						});
					}
				});
			},
			
			editHandle(data) {
				this._edit = !!data;
				if (data) {
					this.request({
						url: '/project/detail',
						data: {
							project_id: data.id
						},
						loading: true,
						success: data => {
							this.$refs.editProjectForm.set({
								project_id: data.project_info.id
							});
							this.$refs.editProjectForm.set(data.project_info);
							this.$refs.editProject.open({
								title: '编辑项目'
							});
						}
					});
				} else {
					this.$refs.editProjectForm.clear();
					this.$refs.editProject.open({
						title: '新建项目'
					});
				}
			},
			
			editSubmitHandle(stop, next) {
				stop();
				
				this.$refs.editProjectForm.submit({
					url: this._edit ? '/project/update' : '/project/add',
					
					rule: {
						name: '请填写项目名称',
						yzdw_id: '请选择所属业主单位',
						yzdw_organization_id: '请选择所属组织部门',
						sshy: '请选择所属行业',
						district: '请选择项目建设地址',
						address: '请填写项目建设详细地址',
						files_path: '请上传招标文件',
						zbdl_money_user_type: '请选择招标代理费付款方'
					},
					
					success: () => {
						next();
						this.$message({
							text: '提交成功'
						});
						this.$refs.table.update(this._edit ? 0 : 1);
					}
				});
			},
			
			deleteHandle(data) {
				this.$confirm({
					text: '确定要删除此项目吗？',
					resolve: () => {
						this.request({
							url: '/project/delete',
							data: {
								project_id: data.id
							},
							loading: true,
							success: () => {
								this.$message({
									text: '删除成功'
								});
								this.$refs.table.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
